import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const FLDetails = ({
  featured_lessons,
  flIndex,
  goBackHandler,
  nextFLHandler,
  prevoiousFLHandler,
  campaignUrl
}) => {
  const iframeRef = useRef();

  const [iframeHeight, setIframeHeight] = useState(635 + 50);
  const [iframeWidth, setIframeWidth] = useState(614);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.data === 'Exit') {
        goBackHandler();
      }
    };

    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  useEffect(() => {
    setIframeHeight(`${iframeRef.current.contentWindow.document.body.scrollHeight + 50}px`);
    setIframeWidth(`${iframeRef.current.contentWindow.document.body.scrollWidth - 30}px`);
  }, [iframeRef]);

  return (
    <>
      <IframeContainer>
        <Iframe
          src={campaignUrl}
          ref={iframeRef}
          scrolling="no"
          title="Campaign"
          width={iframeWidth}
          height={iframeHeight}
          onLoad={() => {
            iframeRef?.current?.contentWindow.postMessage(JSON.stringify(featured_lessons[flIndex]), '*');
          }}
        />
      </IframeContainer>
      <ArrowsContainer>
        <Arrow
          disabled={flIndex === 0}
          background="#269EE2"
          onClick={prevoiousFLHandler}
          aria-label="Previous Spotlight Material"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={flIndex === featured_lessons.length - 1}
          background="#269EE2"
          onClick={nextFLHandler}
          aria-label="Next Spotlight Material"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </>
  );
};

export default FLDetails;

const IframeContainer = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  min-height: 635px;
  margin-top: 10px;

  ${(parentWidth < 706) && css`
    width: 100% !important;
  `};
`;

const Iframe = styled.iframe`
  min-height: 835px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  border: none;

  ${(parentWidth > 627) && css`
    min-width: 628px !important;
  `};

  ${(parentWidth < 629) && css`
    width: 100% !important;
  `};
`;
